// src/pages/HomeAppliancesPage.jsx
import React from "react";
import './homeappliances.css';
import appliancesMainImg from "../assets/homeappli.jpg"; // updated path

export default function HomeAppliancesPage() {
  return (
    <div className="homeappliances-container">

      {/* Top Image */}
      <div className="homeappliances-top-image">
        <img src={appliancesMainImg} alt="Home Appliances" />
      </div>

      {/* Page Title */}
      <h1>Home Appliances</h1>

      {/* Description */}
      <p>
        Explore our wide range of home appliances designed to make your life easier and more comfortable. 
        From kitchen gadgets like mixers, blenders, and microwaves to cleaning essentials like vacuum cleaners, 
        irons, and washing machines, we have everything to keep your home running smoothly. 
        All our products are from trusted brands and come with guaranteed quality. 
        Find the latest innovations and energy-efficient appliances to save time, energy, and money. 
        Shop with confidence and bring convenience to your home today.
      </p>

    </div>
  );
}